import { supabaseClient } from '@plataforma/supabase-client';

import { limpiarCambiosPendientes } from './estado-publicacion.js';

/**
 * @param {string} empresaId
 */
export async function publicarTienda(empresaId) {
  const { data, error } = await supabaseClient().functions.invoke('publicar_tienda', {
    body: { empresa_id: empresaId },
  });

  if (error) {
    let mensaje = error.message;
    try {
      const cuerpo = await error.context?.json?.();
      if (cuerpo?.error) mensaje = cuerpo.error;
    } catch {
      // Se conserva el mensaje original de supabase-js.
    }
    return { data: null, error: { message: mensaje } };
  }

  // La publicación exitosa deja la tienda al día: ya no hay cambios
  // pendientes. Se limpia aquí (único punto de éxito) en vez de en cada
  // vista que llame a esta función, para no duplicar lógica.
  limpiarCambiosPendientes();

  return { data, error: null };
}
